import React from "react";
import { useSelector } from "react-redux";
import { getApiUrl, VACHANA_API_URL } from "utils";

function LeftBarDesign(props) {
  const logoImage = window.sessionStorage.getItem("logo");
  const { gradientColor, titleColor } = useSelector((state) => state.theme);
  const apiUrl = getApiUrl();
  const isVachana = apiUrl === VACHANA_API_URL;
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="row">
        <div
          className={`col-md-3 ${
            !isVachana && "d-sm-none d-none d-md-block d-lg-block"
          }`}
          style={{
            background: `linear-gradient(${gradientColor.toString()})`,
            minHeight: "100vh",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          }}
        >
          <div className="text-center mt-4">
            <img
              src={logoImage}
              className="w-50"
              alt="Logo"
            />
          </div>
          {isVachana && (
            <div
              className="text-center mt-4 pt-4"
              style={{ color: titleColor }}
            >
              <h5>Welcome to the world of trading and investing</h5>
              <h6>
                For any assistance call us <br /> @ <a href="tel:08049674900" style={{ color: titleColor }} rel="noopener noreferrer">080 4967 4900</a>
              </h6>
              <h6>
                Or Email us to{" "}
                <a
                  href="mailto:support@vachanainvestments.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: titleColor }}
                >
                  support@vachanainvestments.com
                </a>
              </h6>
            </div>
          )}
        </div>
        <div
          className="col-md-9"
          style={{
            height: "100vh",
            overflow: "auto",
          }}
        >
          <div className="row">
            <div className="col-md-12 p-5">{props.innerDesign}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LeftBarDesign;
